import logo from "@/assets/hiredcoach-logo.svg";

interface AuthBrandPanelProps {
  title: string;
  body: string;
}

const AuthBrandPanel = ({ title, body }: AuthBrandPanelProps) => {
  return (
    <div className="hidden md:block md:w-1/2 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.14),_transparent_42%),linear-gradient(135deg,#243247_0%,#2f5f88_48%,#4f9ecb_100%)]">
      <div className="flex h-full flex-col justify-center items-center p-10 text-white">
        <img
          src={logo}
          alt="HiredCoach Logo"
          className="w-full max-w-sm"
        />
        <h2 className="mt-8 text-center text-4xl font-bold leading-tight">{title}</h2>
        <p className="mt-4 max-w-xl text-center text-lg leading-8 text-slate-100">
          {body}
        </p>
      </div>
    </div>
  );
};

export default AuthBrandPanel;
